import { useCallback } from 'react';
import { useAtom } from 'jotai';
import { AnalysisCuboid } from '@/types';
import { CuboidBase, CuboidDataHandlers } from '@/modules/cuboids/types';
import { useCuboidState } from './useCuboidState';
import { generateMongoObjectId } from '@/utils/databaseHelpers';

export const useCuboidDataHandlers = (): CuboidDataHandlers<AnalysisCuboid> => {
  const cuboidState = useCuboidState();

  const [cuboids, setCuboids] = useAtom(cuboidState.cuboids);

  const canCreateCuboid = useCallback(() => true, []);

  const createCuboid = useCallback(
    ({ position, rotation, scale }: CuboidBase): AnalysisCuboid | undefined => {
      const id = generateMongoObjectId();

      const newCuboid: AnalysisCuboid = {
        id,
        position,
        rotation,
        scale,
        // poiId
      };
      return newCuboid;
    },
    []
  );

  const addUpdateCuboid = useCallback(
    (cuboid: AnalysisCuboid) => {
      setCuboids((current) => {
        const newCuboids = current.asMutableStateMap();
        newCuboids?.set(cuboid.id, cuboid);
        return newCuboids.asStateMap();
      });
    },
    [setCuboids]
  );

  const deleteCuboid = useCallback(
    (cuboid: AnalysisCuboid) => {
      setCuboids((current) => {
        const newCuboids = current.asMutableStateMap();
        newCuboids.delete(cuboid.id);
        return newCuboids?.asStateMap();
      });
    },
    [setCuboids]
  );

  return {
    cuboids,
    canCreateCuboid,
    createCuboid,
    addUpdateCuboid,
    deleteCuboid,
    updateLoading: false,
    updateError: undefined,
    deleteLoading: false,
    deleteError: undefined,
  };
};
